import ApiRoutes from '../routes/ApiRoutes';
import FetchHelper from '../utils/fetchHelper';

const EcwidProfileApi = {
  show: async (storeId, params) => {
    const url = ApiRoutes.publicEcwidApiV3ProfileUrl(storeId);
    const response = await FetchHelper.get(url, params);
    return response;
  },
};

export default EcwidProfileApi;
